export default "__VITE_ASSET__B_SHw6or__"